import { EventsTable } from "@/components/events/events-table";
import { TableHeader } from "@/components/events/table-header";
import { createFileRoute } from "@tanstack/react-router";

function Events() {
  const { calendarId } = Route.useParams();

  return (
    <div>
      <TableHeader calendarId={calendarId} />
      <EventsTable />
    </div>
  );
}

export const Route = createFileRoute(
  "/_authenticated/calendar/$calendarId/events/",
)({
  component: () => <Events />,
});
